
import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components'

const SectionContainer = styled.section`
    padding: 30px;
    
    @media (min-width: 768px) {
        padding: 50px 30px;
    }
`
const PostsContainer = styled.div`
    display: grid;
    margin: 0 auto;
    max-width: 900px;
    text-align: center;
    justify-content: center;
    grid-template-columns: 100%;

    &.noPosts {
        grid-template-columns: 100%;

        >div {
            max-width: 600px;
            margin: 0 auto;
            padding: 30px 0;
            color: #dc9a98;
        }
    }

    @media (min-width: 620px) {
        grid-template-columns: 50% 50%;
    }
    @media (min-width: 1024px) {
        grid-template-columns: 33% 33% 33%;
    }
`
const PostContainer = styled.div`
    height: 235px;
    overflow: hidden;
    max-width: 238px;
    margin: 10px auto;
    border-radius: 5px;
    border: 1px solid whitesmoke;
    transition: box-shadow .2s ease-in-out;
    box-shadow: 0px 0px 20px rgb(132 132 132 / 10%);
    
    @media (min-width: 620px) {
        max-width: 80%;
    }
    @media (min-width: 768px) {
        height: 325px;
        max-width: 325px;
    }
    @media (min-width: 1024px) {
        margin: 10px;
        height: 275px;
        max-width: 100%;
    }

    &:hover {
        box-shadow: 0px 0px 20px rgb(132 132 132 / 30%);
    }
`
const Title = styled.h2`
    margin: 0 auto;
    padding: 10px;
    font-size: 23px;
    max-width: 900px;
    text-align: center;
    box-sizing: border-box;
    
    @media (min-width: 768px) {
        text-align: left;
    }
    @media (min-width: 1150px) {
        font-size: 40px;
        text-align: left;
        padding: 10px 20px;
    }
`

const Podcast = ({position}) => {
    const [hasError, setError] = useState({});
    const [posts, setPosts] = useState('');
    const containerRef = useRef(null);
 
    useEffect(() => {
        const { current } = containerRef;

        position(current.offsetTop)
    })

    const fetchData = async () => {
        const url = 'https://graph.instagram.com/me/media?fields=id,permalink,media_url&access_token=IGQVJXNlVVZAlJnUXo1a3ZAXRFQ0aDZABUXBIV19qblpvMkhheHFPVVRNTXlhdk5tNndONHpYdGZAxWG93RUxIMDkwdnAwX2pHdTNfVldjRnlwcXpCVC1ZAMENOQkJJWkdrQW5qTTFqUGtTMUwweVYxMDFLNAZDZD';
        const getPosts = await fetch(url);
        const result = await getPosts.json();

        try {
            setPosts(result.data);
        } catch(error) {
            setError(error);
        };
    }
    
    useEffect(() => {
        if (!posts) {
            fetchData();
        }
    }, [hasError, posts]);

    const post = (Array.isArray(posts))
        ? posts.map(item => {
            const isVideo = (new RegExp(/.mp4\?+/g)).test(item.media_url)

            if (isVideo) return ''

            return (
                <PostContainer key={item.id}>
                <a href={item.permalink} target="_blank" rel="noopener noreferrer">
                <img src={item.media_url} alt={`Instagram post ${item.id} `} />
                </a>
                </PostContainer>
            )
        })
        : <div><h1>No posts available at the moment, please reload this page.</h1></div>;

    const emptyClass = (!posts) ? 'noPosts' : '';

    return (
        <SectionContainer id="SocialFeed" ref={containerRef}>
            <Title>Keeping up with us?</Title>

            <PostsContainer className={emptyClass}>
                {post}
            </PostsContainer>
        </SectionContainer>
    );
};

export default Podcast;
